import React from "react";
import { Icon, Badge, Button } from "@elaniintc/goes-design-system";
import { GripHandle } from "@/components/ui/grip-handle";
import type { FormField } from "../types";

interface FieldCardProps {
  field: FormField;
  fieldInfo: { label: string; icon: string };
  onDeleteField: (sectionId: string, fieldId: string) => void;
  sectionId: string;
  onEditField: (sectionId: string, field: FormField) => void;
  showGrip?: boolean;
  gripProps?: React.HTMLAttributes<HTMLSpanElement>;
  isDragging?: boolean;
}

const FieldCard: React.FC<FieldCardProps> = ({
  field,
  fieldInfo,
  onDeleteField,
  sectionId,
  onEditField,
  showGrip = false,
  gripProps,
  isDragging = false,
}) => (
  <div
    className={`flex items-center gap-3 p-2 border-neutral-quiet rounded-lg border ${isDragging ? "cursor-grabbing" : ""}`}
  >
    {showGrip && (
      <span className="flex items-center cursor-grab" {...gripProps}>
        <GripHandle />
      </span>
    )}
    <Icon type="far" name={fieldInfo.icon} className="text-body" />
    <div className="flex-1 min-w-0">
      <div className="font-semibold text-body truncate text-base">
        {field.name || "Nombre del campo"}
      </div>
      <div className="text-sm text-body-quiet">{fieldInfo.label}</div>
    </div>
    {field.required && (
      <Badge variant="info" className="text-xs rounded-full">
        Requerido
      </Badge>
    )}
    <Button
      variant="ghost"
      className="w-8 h-8"
      onClick={() => onEditField(sectionId, field)}
      aria-label="Editar campo"
    >
      <Icon type="far" name="pen" />
    </Button>
    <Button
      variant="ghost"
      className="w-8 h-8"
      onClick={() => field.id && onDeleteField(sectionId, field.id)}
      aria-label="Eliminar campo"
    >
      <Icon type="far" name="close" />
    </Button>
  </div>
);

export default FieldCard;
